import { InjectionToken } from "@angular/core";
import { RequirementsPort } from "./requirements.port";

export const REQUIREMENTS_PORT = new InjectionToken<RequirementsPort>("REQUIREMENTS_PORT");
